import { configureStore, createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosClient } from './api/axiosClient';

export const fetchBillById = createAsyncThunk(
  'excel/fetchBillById',
  async (id, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(`/api/download-center/json/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Lỗi gọi API');
    }
  }
);

const excelSlice = createSlice({
  name: 'excel',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBillById.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(fetchBillById.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data || null;
      })
      .addCase(fetchBillById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message || 'Lỗi không xác định';
      });
  },
});

export const store = configureStore({
  reducer: {
    excel: excelSlice.reducer,
  },
});

